import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as ModalActions from '../../../stores/actions/modal';
import MultiButtonConfirmationModal from './multi-button-confirmation-modal';
import { GreenroomState } from '../../../stores/types/types';

export default function RecordingFailed(): JSX.Element {
	const modalData = useSelector((state: GreenroomState) => state.ModalReducer.modalData);

	const dispatch = useDispatch();

	const closeModal = () => {
		dispatch(ModalActions.setModalOpen(false));
	};

	return (
		<MultiButtonConfirmationModal
			className='broadcast-failed'
			headerText='Recording download failed to process'
			secondButtonText='Close'
			secondButtonAction={closeModal}
			secondButtonClassName='button-option'
			isOpen
		>
			<div style={{marginTop: '8px'}}>
				Please copy the following information:
			</div>
            <div style={{margin: '8px 0'}}>{modalData.linkToRecording ?? ''}</div>
            <div style={{marginBottom: '24px'}}>
				and share it with our support team at <span style={{
					color: '#A6FF79',
					textDecoration: 'none',
				}}>support@brandlive.com </span>and we will share the file back to you as soon as we can.
			</div>
		</MultiButtonConfirmationModal>
	);
}
